import api from '../../auth/apiClient';
import { SAKTI_API_CONFIG } from '../apiConfig';
import {
  CreateAppConfigPayload,
  CreateFeatureFlagPayload,
  SaktiAppConfigDetailResponse,
  SaktiAppConfigListResponse,
  SaktiFeatureFlagAdminDetailResponse,
  SaktiFeatureFlagAdminListResponse,
  UpdateAppConfigPayload,
  UpdateFeatureFlagPayload,
} from '../types';

export class SaktiAppConfigApiService {
  // --- AppConfig ---

  static async listAppConfigs(): Promise<SaktiAppConfigListResponse> {
    const response = await api.get<SaktiAppConfigListResponse>(SAKTI_API_CONFIG.APP_CONFIG_ADMIN_LIST);
    return response.data;
  }

  static async getAppConfig(id: string): Promise<SaktiAppConfigDetailResponse> {
    const response = await api.get<SaktiAppConfigDetailResponse>(SAKTI_API_CONFIG.APP_CONFIG_ADMIN_DETAIL(id));
    return response.data;
  }

  static async createAppConfig(payload: CreateAppConfigPayload): Promise<SaktiAppConfigDetailResponse> {
    const response = await api.post<SaktiAppConfigDetailResponse>(
      SAKTI_API_CONFIG.APP_CONFIG_ADMIN_LIST,
      payload,
    );
    return response.data;
  }

  static async updateAppConfig(id: string, payload: UpdateAppConfigPayload): Promise<SaktiAppConfigDetailResponse> {
    const response = await api.put<SaktiAppConfigDetailResponse>(
      SAKTI_API_CONFIG.APP_CONFIG_ADMIN_DETAIL(id),
      payload,
    );
    return response.data;
  }

  static async deleteAppConfig(id: string): Promise<{ success: boolean }> {
    const response = await api.delete<{ success: boolean }>(SAKTI_API_CONFIG.APP_CONFIG_ADMIN_DETAIL(id));
    return response.data;
  }

  // --- FeatureFlag ---

  static async listFeatureFlags(): Promise<SaktiFeatureFlagAdminListResponse> {
    const response = await api.get<SaktiFeatureFlagAdminListResponse>(SAKTI_API_CONFIG.FEATURE_FLAG_ADMIN_LIST);
    return response.data;
  }

  static async getFeatureFlag(id: string): Promise<SaktiFeatureFlagAdminDetailResponse> {
    const response = await api.get<SaktiFeatureFlagAdminDetailResponse>(
      SAKTI_API_CONFIG.FEATURE_FLAG_ADMIN_DETAIL(id),
    );
    return response.data;
  }

  static async createFeatureFlag(payload: CreateFeatureFlagPayload): Promise<SaktiFeatureFlagAdminDetailResponse> {
    const response = await api.post<SaktiFeatureFlagAdminDetailResponse>(
      SAKTI_API_CONFIG.FEATURE_FLAG_ADMIN_LIST,
      payload,
    );
    return response.data;
  }

  static async updateFeatureFlag(
    id: string,
    payload: UpdateFeatureFlagPayload,
  ): Promise<SaktiFeatureFlagAdminDetailResponse> {
    const response = await api.put<SaktiFeatureFlagAdminDetailResponse>(
      SAKTI_API_CONFIG.FEATURE_FLAG_ADMIN_DETAIL(id),
      payload,
    );
    return response.data;
  }

  static async deleteFeatureFlag(id: string): Promise<{ success: boolean }> {
    const response = await api.delete<{ success: boolean }>(SAKTI_API_CONFIG.FEATURE_FLAG_ADMIN_DETAIL(id));
    return response.data;
  }
}
